import { useMemo } from "react";
import { ColumnInstance } from "react-table";

import { XIcon } from "lucide-react";

import { Button } from "../Button";
import { SearchFilter } from "./components/SearchFilter";

export function TableFilters<TRowData extends object>(props: {
  columns: ColumnInstance<TRowData>[];
  searchTerm: string;
  onSearchChange: (searchTerm: string) => void;
  onResetFilters: () => void;
  isFiltered?: boolean;
  searchPlaceholder?: string;
}) {
  const filters = useMemo(() => {
    return props.columns.filter((x) => x.canFilter && x.Filter);
  }, [props.columns]);

  return (
    <div className="flex flex-wrap gap-x-2 gap-y-2">
      <div className="flex w-full items-end xs:w-36 sm:w-60">
        <SearchFilter
          searchTerm={props.searchTerm}
          onChange={props.onSearchChange}
          placeholder={props.searchPlaceholder}
        />
      </div>
      {filters.map((column) => {
        return <div key={column.id}>{column.render("Filter")}</div>;
      })}
      {filters.length > 0 && (
        <div className="self-end">
          <Button
            size="sm"
            variant="ghost"
            colorScheme={props.isFiltered ? "danger" : "secondary"}
            onClick={() => props.onResetFilters()}
            isDisabled={!props.isFiltered}
            iconRight={<XIcon className="ml-1" />}
            className="text-sm"
          >
            Reset
          </Button>
        </div>
      )}
    </div>
  );
}
